"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TempIllsWithInfo = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDeviceDetect = require("react-device-detect");

var _row = _interopRequireDefault(require("../row"));

var _col = _interopRequireDefault(require("../col"));

var _icon = require("../icon");

var _button = require("../button");

var _illustration = require("../illustration");

var _collapse = _interopRequireDefault(require("../collapse"));

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Panel = _collapse.default.Panel;

var TempIllsWithInfo = function TempIllsWithInfo(_ref) {
  var type = _ref.type,
      illsType = _ref.illsType,
      infoBloc = _ref.infoBloc,
      illsCol = _ref.illsCol,
      illsSize = _ref.illsSize,
      illusAlign = _ref.illusAlign,
      illusStyle = _ref.illusStyle,
      collapseSwitcher = _ref.collapseSwitcher;

  var _useState = (0, _react.useState)(!_reactDeviceDetect.isMobileOnly),
      _useState2 = _slicedToArray(_useState, 2),
      collaseSwitch = _useState2[0],
      setCollaseSwitch = _useState2[1];

  var handleCollaseSwitch = function handleCollaseSwitch() {
    setCollaseSwitch(!collaseSwitch);
  }; // Template Type


  var childrenNode = {};
  var templateClassname = '';
  var illusAlignClassname; // Illustration align type

  switch (illusAlign) {
    case 'center':
      illusAlignClassname = 'illus-align illus-align--center';
      break;

    case 'bottom':
      illusAlignClassname = 'illus-align illus-align--bottom';
      break;

    case 'top':
    default:
      illusAlignClassname = 'illus-align illus-align--top';
      break;
  }

  switch (type) {
    case 'Center':
      templateClassname = 'temp-illsWithInfo--center';
      childrenNode = /*#__PURE__*/_react.default.createElement(_row.default, {
        gutter: 40,
        type: "flex",
        justify: "center"
      }, /*#__PURE__*/_react.default.createElement(_col.default, {
        xs: 20,
        sm: illsCol || 18
      }, /*#__PURE__*/_react.default.createElement(_illustration.Illustration, {
        type: illsType,
        size: illsSize,
        style: illusStyle
      })), /*#__PURE__*/_react.default.createElement(_col.default, {
        span: 24
      }, infoBloc));
      break;

    case 'Bar':
      childrenNode = /*#__PURE__*/_react.default.createElement(_row.default, {
        gutter: 40,
        type: "flex",
        justify: "center",
        align: "middle"
      }, /*#__PURE__*/_react.default.createElement(_col.default, {
        xs: 16,
        sm: 6,
        md: 6
      }, /*#__PURE__*/_react.default.createElement(_illustration.Illustration, {
        type: illsType,
        size: illsSize,
        style: illusStyle
      })), /*#__PURE__*/_react.default.createElement(_col.default, {
        xs: 24,
        sm: 18,
        md: 13
      }, infoBloc));
      break;

    case 'Banner':
      templateClassname = 'temp-illsWithInfo--banner';
      childrenNode = /*#__PURE__*/_react.default.createElement(_row.default, {
        className: "container",
        gutter: 0,
        type: "flex",
        justify: "center",
        align: "middle"
      }, /*#__PURE__*/_react.default.createElement(_col.default, {
        xs: 24,
        sm: 12,
        md: 12
      }, infoBloc), /*#__PURE__*/_react.default.createElement(_col.default, {
        xs: 16,
        sm: 12,
        md: 12,
        className: illusAlignClassname
      }, /*#__PURE__*/_react.default.createElement(_illustration.Illustration, {
        type: illsType,
        size: illsSize,
        style: illusStyle
      })));
      break;

    default:
      childrenNode = /*#__PURE__*/_react.default.createElement(_row.default, {
        gutter: 60,
        type: "flex",
        justify: "center",
        align: "middle"
      }, /*#__PURE__*/_react.default.createElement(_col.default, {
        xs: 16,
        sm: 10,
        md: illsCol || 10
      }, /*#__PURE__*/_react.default.createElement(_illustration.Illustration, {
        type: illsType
      })), /*#__PURE__*/_react.default.createElement(_col.default, {
        xs: 24,
        sm: 14,
        md: illsCol ? 24 - illsCol : 12
      }, infoBloc));
      break;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "temp-illsWithInfo ".concat(templateClassname)
  }, collapseSwitcher ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.Button, {
    type: "Ghost",
    className: "collase-button",
    onClick: handleCollaseSwitch
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      paddingRight: '3px',
      display: 'inline'
    }
  }, collaseSwitch === false ? 'Show tips' : 'Hide tips'), /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    type: collaseSwitch === false ? 'shpmtcdicon-arrow-down' : 'shpmtcdicon-arrow-up',
    style: {
      display: 'inline-block',
      paddingTop: '1px',
      transform: 'scale(1.2)'
    }
  })), /*#__PURE__*/_react.default.createElement(_collapse.default, {
    activeKey: collaseSwitch === true ? 'childrenNode' : null,
    className: "shpmtc-collapseItem-block"
  }, /*#__PURE__*/_react.default.createElement(Panel, {
    key: "childrenNode"
  }, childrenNode))) : childrenNode);
}; // Prop Types


exports.TempIllsWithInfo = TempIllsWithInfo;
TempIllsWithInfo.defaultProps = {
  type: null,
  illsCol: null,
  illsSize: null,
  illusAlign: null,
  illusStyle: null,
  collapseSwitcher: false
};
TempIllsWithInfo.propTypes = {
  type: _propTypes.default.string,
  illsType: _propTypes.default.string.isRequired,
  infoBloc: _propTypes.default.node.isRequired,
  illsCol: _propTypes.default.number,
  illsSize: _propTypes.default.string,
  illusAlign: _propTypes.default.string,
  illusStyle: _propTypes.default.instanceOf(Object),
  collapseSwitcher: _propTypes.default.bool
};